import React from "react";
import '../styles/Stat.css';

function Stat({ label, value }) {
    return (
        <div className='stat-card'>
            <h3 className='stat-value'>{value}</h3>
            <p className='stat-label'>{label}</p>
        </div>
    );
}

export default Stat;